import { Permission } from 'utils/permissions'

export enum THEME_COLORS {
  LIGHT = 'light',
  DARK = 'dark'
}

export const SEED_PANEL_SECTION_PERMISSIONS: ReadonlyArray<string> = [
  Permission.CAN_ACCESS_TEACHER_PANEL,
  Permission.CAN_ACCESS_USAGE_ANALYTICS,
  Permission.CAN_MANAGE_READING_GOALS,
  Permission.CAN_MANAGE_RUNNING_RECORDS,
  Permission.CAN_MANAGE_ACTIVITIES,
  Permission.CAN_MANAGE_USERS,
  Permission.CAN_MANAGE_COLLECTIONS,
  Permission.CAN_MANAGE_PERMISSIONS,
  Permission.CAN_MODERATE_DISCUSSIONS
]

export const TEACHER_TUTORIAL_URL =
  'https://central.arvore.com.br/central/educador?utm_source=plataforma&utm_medium=referral&utm_content=menu_superior_tutoriais_educador&utm_campaign=central_2023'
export const STUDENT_TUTORIAL_URL =
  'https://central.arvore.com.br/central/estudante?utm_source=plataforma&utm_medium=referral&utm_content=menu_superior_tutoriais_estudante&utm_campaign=central_2023'

export const SECRETARIA_SP_HELP_PATH = 'https://portal.arvore.com.br/bibliosp'

export const RECIFE_HELP_PATH = 'https://portal.arvore.com.br/recife'

export const BIBLION_HELP_PATH = 'https://centralbiblion.arvore.com.br/'
